/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { CreateBuchungForTimeframeDto } from '../../models/create-buchung-for-timeframe-dto';

export interface CreateBuchungForMitarbeiterInTimeframe$Json$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  
    /**
     * Daten für die Buchung
     */
    body?: CreateBuchungForTimeframeDto
}

export function createBuchungForMitarbeiterInTimeframe$Json(http: HttpClient, rootUrl: string, params: CreateBuchungForMitarbeiterInTimeframe$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, createBuchungForMitarbeiterInTimeframe$Json.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungDto>>;
    })
  );
}

createBuchungForMitarbeiterInTimeframe$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/buchungen/timeframe';
